import mfaAndResetDeliveryOptionsTemplate from "../core/mfaAndResetDeliveryOptionsTemplate";

const activationCodeDeliveryOptionsTemplate = `
<div class="col-md-6 col-md-offset-3 col-sm-8 col-sm-offset-2 registration">

    <header class="contained-form-header">
        <h1>
            {{ "step2MfaTitle" | translate }}
            <span class="registration-progress">(2 of 3)</span>
        </h1>
        <p ng-if="!mfa.editContactInfoAllowed">{{ "step2MfaDetailsInREG" | translate }}</p>
        <p ng-if="mfa.editContactInfoAllowed">{{ "step2MfaDetails" | translate }}&nbsp;If you do not receive the code within 3 minutes, <a ng-show="$state.current.name === 'activationCodeDeliveryOptions' && emptyDeliveryOptionsMessage == null&&mfa.editContactInfoAllowed" ng-click="redirectToContactInfoFromMFA()">please verify your contact information</a>  to ensure the phone number or email address you provided is accurate.</p>
    </header>

    <div class="inner-container with-padding with-shadow">
        <form role="form" name="deliveryOptions-form" data-ng-init="getDeliveryOptions()" data-ng-submit="createAndDeliverActivationCodePOST('mfa')" aria-live="polite">
            ${mfaAndResetDeliveryOptionsTemplate}
        </form>
    </div><!--/inner-container with-padding with-shadow/-->
</div>
`;
export default activationCodeDeliveryOptionsTemplate;